import { ApiPathConfig } from '../types';
import { callApi } from './ApiCall';
import { AxiosClient } from 'infrastructure/axiosClient/AxiosClient';

export abstract class BaseApi {
  public constructor(protected readonly axiosClient: AxiosClient) {}

  protected callApi<TRequest, TResponse>(
    config: ApiPathConfig<TRequest, TResponse>,
    dto: TRequest
  ): Promise<TResponse>;

  protected callApi<TRequest>(config: ApiPathConfig<TRequest, void>, dto: TRequest): Promise<void>;

  protected callApi<TResponse>(
    config: ApiPathConfig<void, TResponse>,
    dto: void
  ): Promise<TResponse>;

  protected callApi(config: ApiPathConfig<void, void>, dto: void): Promise<void>;

  protected callApi<TRequest, TResponse>(
    config: ApiPathConfig<TRequest, TResponse>,
    dto: TRequest
  ): Promise<TResponse | void> {
    return callApi<TRequest, TResponse>(config, this.axiosClient, dto);
  }
}
